import $ from "jquery";

$(document).on("turbolinks:load", function () {
  const tableSelector = ".simple-expandable-table-row";

  $(document).on("click", `${tableSelector} [data-setr-parent-id]`, function () {
    const clicked = $(this);
    const id = clicked.data().setrParentId;
    const children = clicked.closest(tableSelector).find("[data-setr-child-id='" + id +"']");
    const detailChild = children.filter(".details");
    clicked.toggleClass("expanded");

    if (clicked.hasClass("expanded")) {
      children.removeClass("hidden");
      detailChild.addClass("expanded");
    } else {
      children.addClass("hidden");
      children.removeClass("expanded");

      clicked.closest(tableSelector).find("[data-setr-grand-child-id='" + id +"']").addClass("hidden");
    }

    children.find(".short-description").removeClass("hidden");
    children.find(".full-description").addClass("hidden");


    clicked.find(".short-description, .full-description").toggleClass("hidden");
  });

  $(document).on("click", `${tableSelector} [data-setr-child-id]`, function () {
    const clicked = $(this);
    const id = clicked.data().setrChildId;
    if (!id || clicked.data().setrParentId) {
      return;
    }
    const clickedParent = clicked.closest(tableSelector).find("[data-setr-parent-id='" + id +"']");

    clickedParent.removeClass("expanded");

    clicked.addClass("hidden");
    clicked.removeClass("expanded");
    clickedParent.find(".short-description").removeClass("hidden");
    clickedParent.find(".full-description").addClass("hidden");
  });
});
